import { useFeatureGate } from '@trello/feature-gate-client';

import { useMaliciousCardCoverAttachmentFragment } from './MaliciousCardCoverAttachmentFragment.generated';

export const useHasMaliciousCoverAttachment = ({
  cardId,
}: {
  cardId: string;
}) => {
  const { data: card } = useMaliciousCardCoverAttachmentFragment({
    from: { id: cardId },
    optimistic: true,
  });

  const coverAttachmentId = card?.idAttachmentCover;
  const attachments = card?.attachments;

  const { value: isMalwareScanningFeatureEnabled } = useFeatureGate(
    'phx_malware_scanning_for_attachments',
  );

  if (
    !coverAttachmentId ||
    !attachments?.length ||
    !isMalwareScanningFeatureEnabled
  ) {
    return false;
  }

  return attachments.some(
    (attachment) =>
      attachment.id === coverAttachmentId && attachment?.isMalicious,
  );
};
